import Mainnav from 'modules/Common/Components/Mainnav';
import { Suspense, FC } from 'react';
import styled from 'styled-components';
import SettingStickyHeader from './Forms/SettingStickyHeader';
import { PageParams } from 'constants/interfaces/GlobalInterfaces';
import { useHistory } from 'react-router-dom';
import FormDetails from './Forms/FormDetails';
import ManageWrapper from './Manage/Shared/ManageWrapper';
import CardLayout from './Forms/Components/CardLayout';
import SettingRedirectionCard from './Components/SettingRedirectionCard';
import { ReactComponent as Xelator } from '../../assets/img/xelator.svg.svg';
import { ReactComponent as Form } from '../../assets/img/FormIcon.svg';
import { useSelector } from 'react-redux';

const Wrapper = styled.div<{ page?: string }>`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.page !== 'forms' ? '9em' : '9em')};
  margin-left: ${(props) => (props.page === undefined ? '64px' : '0')};
  .redirection-card {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    margin-bottom: 16px;
    margin-top: 24px;
    :hover {
      color: #1ec252 !important;
    }
  }
  /* @media all and (min-width: 1440px) and (max-height: 729px) {
    margin-top: ${(props) => (props.page !== 'forms' ? '9em' : '0')};
  }
  @media all and (min-width: 1440px) and (min-height: 730px) {
    margin-top: ${(props) => (props.page !== 'forms' ? '12em' : '0')};
  } */
  // @media all and (min-width: 1440px) and (max-width: 1920px) and (-webkit-device-pixel-ratio: 1.25) {
  //   margin-top: 10em;
  // }
  // @media all screen and (min-width: 1280px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
  //   margin-top: 10em;
  // }
  // @media all and (max-width: 1919px) {
  //   margin-top: 126px !important;
  // }
  /* @media all and (max-width: 1439px) and (min-height: 730px) {
    margin-top: ${(props) => props.page === 'forms' && '0'};
  } */
  @media all and (max-width: 1280px) {
    // margin-top: 126px !important;
    .setting-page-card {
      width: 400px !important;
    }
    .redirection-card-title {
      font-size: 18px !important;
      sup {
        font-size: 60% !important;
      }
    }
    .card-title {
      font-size: 18px !important;
      line-height: 20px !important;
      margin-bottom: 4px !important;
    }
    .card-description {
      font-size: 13px !important;
      line-height: 20px !important;
    }
  }
`;
const Header = styled.div`
  .title {
    color: #424b50;
    font-family: 'Roboto Slab';
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 39px;
    margin: 0;
  }
  .sub-title {
    color: #7e7e7e;
    font-family: 'Roboto';
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-top: 6px;
    margin-bottom: 0;
  }
  @media all and (max-width: 1280px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    .title {
      font-size: 18px !important;
      line-height: 20px !important;
    }
    .sub-title {
      font-size: 13px !important;
    }
  }
`;
const Settings: FC<PageParams> = (props) => {
  const history = useHistory();
  const exportWidgetPermission = useSelector((state) => state?.user?.userData?.export_widget_permission);
  const manageFormPermission = useSelector((state) => state?.user?.userData?.manage_form_permission);

  const { page, tab } = props;

  const content = [
    {
      id: 1,
      title: (
        <p className="redirection-card-title">
          Sales Xelerator<sup>TM</sup> Groups
        </p>
      ),
      description: 'Organize your team into groups to share marketing collateral and more.',
      image: <Xelator />,
      redirection: () => history.push('settings/groups'),
    },
    {
      id: 2,
      title: 'Forms',
      description: 'Simplify lead generation and data  collection with our Forms and Form Handlers.',
      image: <Form />,
      redirection: () => history.push('settings/forms'),
    },
  ];

  const checkUserPermission = (id: number) => {
    let permission = false;
    switch (id) {
      case 1: //Export Widget Permission
        permission = exportWidgetPermission;
        break;
      case 2: //Manage Form Permission
        permission = manageFormPermission;
        break;
      default:
        permission = false;
    }
    return permission;
  };
  return (
    <>
      <Suspense fallback={<></>}>
        <Mainnav />
      </Suspense>
      <Suspense fallback={<></>}>
        <SettingStickyHeader />
      </Suspense>
      {page === 'groups' ? <ManageWrapper page={page} tab={tab} /> : ''}
      <Wrapper page={page}>
        {page === undefined ? (
          <>
            <Header>
              <p className="title">Manage</p>
              <p className="sub-title">Manage your preferences and configurations here:</p>
            </Header>
            <div className="redirection-card">
              {content.map(
                (item, index) =>
                  checkUserPermission(item.id) && (
                    <CardLayout
                      className="setting-page-card"
                      onClick={item.redirection}
                      width={'100%'}
                      maxWidth={'451px'}
                      margin={''}
                      padding={'40px 66px'}
                      height="160px"
                    >
                      <SettingRedirectionCard key={index} title={item.title} description={item.description} image={item.image} />
                    </CardLayout>
                  ),
              )}
            </div>
          </>
        ) : null}
        {page === 'forms' ? <FormDetails page={page} tab={tab} /> : ''}
      </Wrapper>
    </>
  );
};

export default Settings;
